import React, { useState, createContext } from 'react'
import createTheme from '../theme'
import { ThemeProvider, StyledEngineProvider, adaptV4Theme } from '@mui/material/styles'

const initialState = true

export const CustomThemeContext = createContext(initialState)

export function CustomThemeProvider ({ children }) {
  const [isDarkTheme, setIsDarkTheme] = useState(initialState)

  return (
    <CustomThemeContext.Provider value={{ isDarkTheme, setIsDarkTheme }}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={createTheme(adaptV4Theme({ darkTheme: isDarkTheme }))}>
          {children}
        </ThemeProvider>
      </StyledEngineProvider>
    </CustomThemeContext.Provider>
  )
}
